import axios from "axios";
import { fetchBranding } from "./branding.service";

const API_URL = "/api/agency";

export let _agency = null;

export async function fetchCurrent() {
  if (_agency) {
    return _agency;
  }

  const branding = await fetchBranding();
  const response = await axios.get(`${API_URL}/current`);
  const isPURL = !!response.data;

  // If no agency from API, use branding config
  const currentAgency = response.data || {
    name: branding.name,
    logo: {
      src: branding.logoPath,
      title: branding.name,
    },
    isPURL: false,
  };

  if (!!currentAgency.domain?.length) {
    const urlBase = `${window.location.protocol}//${currentAgency.domain}`;
    currentAgency.mainURL = new URL("/", urlBase);
    currentAgency.adminURL = new URL("/admin", urlBase);
  } else {
    currentAgency.mainURL = new URL("/", window.location.href);
    currentAgency.adminURL = new URL("/admin", window.location.href);
  }

  // Ensure logo comes from branding if not set
  if (!currentAgency.logo?.src?.length) {
    currentAgency.logo = {
      src: branding.logoPath,
      title: branding.name,
    };
  }

  currentAgency.isPURL = isPURL;
  _agency = currentAgency;
  return currentAgency;
}

// #38 - the logged-in principal's downline as a nested agency tree with agents at
// every level. Returns { id, name, agents[], children[], totalAgents, totalAgencies }.
export async function fetchDownlineTree() {
  const response = await axios.get(`${API_URL}/downline-tree`);
  return response.data;
}

const AgencyService = {
  current: fetchCurrent,
  downlineTree: fetchDownlineTree,
  clear: () => {
    _agency = null;
  },
};

export default AgencyService;
